<template>
    <Overlay :show="runtimeState.isBusy">
        <BAlert
            v-if="runtimeState.isCompleted"
            variant="success"
            show
            class="mb-0"
        >
            <div class="alert-body">
                {{ $t('Page(ReceivedRequest):Component(SendReplyAck):text') }}
            </div>
        </BAlert>
        <LegacySendReply
            v-else
            :reply-details="context.request.replyDetails"
            @send="$emit('execute-terminal')"
        />
    </Overlay>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import Overlay from '@core/components/common/Overlay.vue'
import LegacySendReply from '@/views/request/received/flow/components/vertiacal-steps/SendReply.vue'

export default {
    name: 'SendReplyStep',
    components: {
        BAlert,
        LegacySendReply,
        Overlay,
    },
    props: {
        context: { type: Object, required: true },
        settings: { type: Object, required: true },
        runtimeState: { type: Object, required: true },
    },
}
</script>
